export const ruffTimeView = () => ({
  type: 'Views loading error page',
});
